let currencySymbol = '$';
let currencyISO = 'AUD';

if (Shopify) {
  currencyISO = Shopify.currency.active;
}

const moneyFormat = (amount) => {
  return `${currencySymbol}${(amount / 100).toFixed(2)}`;
}

const fetchCart = async () => {
    try {
      const res = await fetch('/cart.js');
      const data = await res.json();
      if (res.ok) return data;
    } catch (error) {
      console.log(error);
      return null
    }
}

class CartThreshold extends HTMLElement {
    constructor() {
      super();

      if(currencyISO != 'AUD') return;

      this.enabledTargets = [];
      this.maxTarget = 0;
      this.script = this.querySelector('script');
      this.data = this.script ? JSON.parse(this.script.textContent) : null;
      if (!this.data) return;

      this.data.targets.forEach(target => {
        if(target.value > 0) {
            this.enabledTargets.push(target);
        }
      })
      if (!this.enabledTargets.length) return;

      this.enabledTargets = this.enabledTargets.sort((a, b) => a.value - b.value);
      const allTargets = this.enabledTargets.map(({ value }) => value);
      this.maxTarget = Math.max(...allTargets);
      if (this.maxTarget === 0) return;

      this.#renderElements();
      this.#init();
  
      document.addEventListener('cart:updated', (evt) => {
        const { detail: { cart } } = evt;
        this.#calculateShipping(cart);
      });
    }

    #convertToCurrency(amount) {
        return Shopify?.currency?.rate ? Math.trunc(Shopify.currency.rate * +amount) : Math.trunc(+amount)
    }

    async #init() {
        const cartData = await fetchCart();
        this.#calculateShipping(cartData);
    }

    #renderElements() {
        const target= this.#convertToCurrency(this.maxTarget);
        /*
        const renderProgressDots = this.enabledTargets.map(({ name, value }, index) => {
            return `
              <span
                class="promo-dots promo--${name} promo--${name}-${index}"
                data-target="${value}"
                data-currency-symbol="${currencySymbol}"
                aria-hidden="true"
                style="--position: ${(value/this.maxTarget) * 100}; --value: ${value}">
              </span>
            `
        }).join('');
        */
    
        const html = `
          <div id="cart-promotions-message" class="cart-promotions-message"></div>
          <div class="cart-promotions-wrapper" data-target="${target}" data-currency-symbol="${currencySymbol}">
            <label for="cart-promotions" class="visually-hidden">Cart Promotions</label>
            <progress id="cart-promotions" max="100" value="0" data-target="${target}"></progress>
            <div class="cart-promotions-max-target">SPEND $${target}</div>
          </div>
        `;
    
        this.innerHTML = html;
    }
    #calculateShipping(cartJson) {
        const targets = this.enabledTargets;
        const total = cartJson.total_price && cartJson.total_price > 0 ? cartJson.total_price : 0;
        const cartTotal = total > 0 ? total / 100 : 0;
        const progressValue = (cartTotal / this.#convertToCurrency(this.maxTarget)) * 100;
        const container = document.getElementById('cart-promotions');
        let message = '';
    
        if (progressValue >= 100) {
          container.setAttribute('value', 100);
          container.parentElement.setAttribute('value', 100);
        } else {
          container.setAttribute('value', progressValue ? progressValue : 0);
          container.parentElement.setAttribute('value', progressValue ? progressValue : 0);
        }
    
        if (!this.maxTarget) {
          message = 'Please enter target amounts in Theme Settings > Cart Promotions'
          return;
        }
    
        if (cartTotal <= 0) {
          message = "";
        } else {
          for (const [index, target] of targets.entries()) {
            const promoDot = this.querySelector(`.promo--${target.name}-${index}`);
            const remaining = this.#convertToCurrency(target.value) - cartTotal;
    
            if (remaining <= 0) {
              message = `<span>${target.success}</span><br/>`;
              if (promoDot) promoDot.classList.add('active');
            } else {
              message += target.label;
              if (promoDot) promoDot.classList.remove('active');
              break;
            }
          }
        }
        // Display message
        document.getElementById('cart-promotions-message').innerHTML = message;
    }

}

customElements.define('widget-cart-threshold', CartThreshold);